import ProjectUnit from './ProjectUnit';
import classes from './Projects.module.css';
import Skin from '../../../assets/images/skinsyBG.jpg';
import Aquastar from '../../../assets/images/aquastarBG.jpg';
import BentoBox from '../../../assets/images/bentoBoxBG.jpg';
import NewsMonkey from '../../../assets/images/newsMonkey.jpg';
import SpotifyBg from '../../../assets/images/spotifyBg.jpg';
import TodoBg from '../../../assets/images/todoBg.jpg';
const DEFAULT_PROJECT = [
  {
    name: 'Spotify Clone',
    description:
      "Dive into the future of music with my Spotify Clone – a sleek and user-friendly project blending seamless song management, playback, and liking functionalities. Crafted with precision using modern web technologies, it's more than a clone it's a symphony of innovation and user-centric design.",
    tech: 'NextJs,TailwindCss,Supabase,Typescript',
    link: 'https://github.com/rahul-tsx/spotify-clone',
    liveLink: 'https://spotify-clone-two-taupe.vercel.app',
    image: SpotifyBg,
  },
  {
    name: 'Kanban Board',
    description:
      "Elevate your task management game with my Next.js and Tailwind CSS-powered Kanban Board. Featuring a sleek interface and drag-and-drop ease, it's a dynamic solution for organized and visually appealing task tracking. Experience efficiency in style!",
    tech: 'NextJs,TailwindCss,Typescript',
    link: 'https://github.com/rahul-tsx/kanban-board',
    liveLink: 'https://kanban-board-five-chi.vercel.app/',
    image: TodoBg,
  },
  {
    name: 'Aquastar',
    description:
      '"AquaStar" - an exceptional ecommerce web application revolutionizing your online shopping experience. With intuitive modules for effortless purchasing, streamlined stock management, secure payments, and a powerful admin section, AquaStar offers a refreshing and reliable platform. Dive into AquaStar for a world of convenience and excellence in online shopping.',
    tech: 'ReactJS,ExpressJS, NodeJS, MongoDB,Bootstrap',
    link: 'https://github.com/rahul-tsx/aquastar',
    image: Aquastar,
  },
  {
    name: 'Skinsy',
    description:
      '"Skinsy" - your smart skin health companion. This mobile app uses advanced deep learning to identify skin diseases from images. Snap a photo, get quick results, and proactively care for your skin. Rest assured, your privacy is protected. Join Skinsy now for convenient and reliable skin health monitoring.',
    tech: 'Python , Android, Firebase, Java, Tensorflow',
    link: 'https://github.com/rahul-tsx/Skinsyapplication',
    image: Skin,
  },
  {
    name: 'Bento Box',
    description:
      ' "Bento Box" - Discover a culinary adventure with Bento Box! Order now for diverse cuisines, easy customization, and real-time tracking. Simplify your food journey and enjoy delightful dining at your doorstep. Your ultimate dining companion awaits!',
    tech: 'ReactJS, FireBase ',
    link: 'https://codesandbox.io/s/github/rahul-tsx/food-order-app',
    image: BentoBox,
  },
  {
    name: 'NewsMonkey',
    description:
      '"NewsMonkey"- your personalized news app! Get up-to-the-minute updates from reliable global sources. Curate your feed effortlessly to stay informed on politics, business, entertainment, sports, and more!',
    tech: 'ReactJS,Bootstrap',
    link: 'https://github.com/rahul-tsx/newsapp',
    image: NewsMonkey,
  },
];

const Projects = () => {
  const units = DEFAULT_PROJECT.map((item, index) => {
    return <ProjectUnit item={item} key={index} />;
  });
  return (
    <>
      <div className={classes.title} id='project-section'>
        Featured Projects: Bringing Ideas to Life
      </div>
      <div className={classes.ProjectsContainer}>{units}</div>
    </>
  );
};
export default Projects;
